import {
  CAMPAIGNPAGE_LOADING,
  GET_CAMPAIGNPAGE,
  GET_DEPTSTRUCTURE,
  GET_CAMPAIGNPAGE_SUCCESS,
  GET_CAMPAIGNPAGE_FAIL,
  ADD_CAMPAIGNPAGE_SUCCESS,
  ADD_CAMPAIGNPAGE_FAIL,
  DELETE_CAMPAIGNPAGE_SUCCESS,
  DELETE_CAMPAIGNPAGE_FAIL,
  UPDATE_CAMPAIGNPAGE_SUCCESS,
  UPDATE_CAMPAIGNPAGE_FAIL,
  CAMPAIGNPAGE_RESET
} from "./actionType";

const INIT_STATE = {
  campaignPages: [],
  structures: [],
  error: {},
};

const CampaignPage = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CAMPAIGNPAGE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CAMPAIGNPAGE:
          return {
            ...state,
            campaignPages: action.payload.data,
            isCampaignPageCreated: false,
            isCampaignPageSuccess: true,
            loading: false,
          };

        case GET_DEPTSTRUCTURE:
          return {
            ...state,
            structures: action.payload.data,
            isCampaignPageCreated: false,
            isCampaignPageSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CAMPAIGNPAGE_FAIL:
      switch (action.payload.actionType) {
        case GET_CAMPAIGNPAGE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCampaignPageCreated: false,
            isCampaignPageSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CAMPAIGNPAGE: {
      return {
        ...state,
        isCampaignPageCreated: false,
        loading: true,
      };
    }

    case CAMPAIGNPAGE_LOADING: {
      return {
        ...state,
        isCampaignPageCreated: false,
        loading: true,
      };
    }

    case ADD_CAMPAIGNPAGE_SUCCESS:
      return {
        ...state,
        isCampaignPageCreated: true,
        loading: false,
        campaignPages: [action.payload.data, ...state.campaignPages],
      };

    case ADD_CAMPAIGNPAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CAMPAIGNPAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        campaignPages: state.campaignPages.filter(
          campaignPage => campaignPage.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CAMPAIGNPAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CAMPAIGNPAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        campaignPages: state.campaignPages.map(campaignPage =>
          campaignPage.id.toString() === action.payload.data.id.toString() ? { ...campaignPage, ...action.payload.data } : campaignPage
        ),
      };

    case UPDATE_CAMPAIGNPAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CAMPAIGNPAGE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default CampaignPage;